const baseUrl = process.env.REACT_APP_OBIE_API_URL

export const obieApi = (endpoint: string) => `${baseUrl}${endpoint}`
